module.exports = "<div class=\"news-view\" v-class=\"loading:!items.length\">\n    <!-- item list -->\n    <item v-repeat=\"item:items\" page=\"{{displayPage}}\" track-by=\"id\"></item>\n    <!-- navigation -->\n    <div class=\"nav\" v-show=\"items.length > 0\">\n      <a v-if=\"params.page > 1\" href=\"#/news/{{params.page - 1}}\">&lt; prev</a>\n      <a v-if=\"params.page < 4\" href=\"#/news/{{params.page + 1}}\">more...</a>\n    </div>\n  </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/html-loader!../vue-loader/lib/selector.js?template!./src/views/news-view.vue
 ** module id = 91
 ** module chunks = 0
 **/